import { Action, createAction, props } from '@ngrx/store';
import { type } from '@app/util/util';

import {
  UserHistoryItem, BookingPoliciesPayload, ExchangeSearchPayload,
  BookingPoliciesResponse, ExchangeBookPayload,
  ExchangeBookResponse, ReservationType
} from '@user-history/entities/user-history-item';
import { HistoryBookingDetail, FullHistoryBookingDetail } from '@user-history/entities/history-booking-detail';
import { RappiPayment } from '@booking/entities/rappi-payment';
import { RappiPaymentResponse } from '@booking/entities/rappi-payment.response';
import {
  CancellationSuccessType,
  CancellationFailureType
} from '@user-history/entities/cancellation.response';
import { UserHistoryOptions } from '@user-history/entities/user-history-options';
import { RequestSearchPayload } from '@flight-results/entities/request-search.payload';
import { CancellationReasonSumbitVM } from '@user-history/entities/cancellation-reasons';

export const fetchUserHistoryListAction = createAction(
  type('[UserHistory/API] Fetch user history list'),
  props<{ userId: string }>()
);
export const userHistoryListAction = createAction(
  type('[UserHistory/DATA] Fetch user history list'),
  props<{ response: UserHistoryItem[] }>()
);

export const fetchHistoryBookingDetailAction = createAction(
  type('[UserHistory/API] Fetch history booking detail'),
  props<{ userId: string, detailId: string, isByValidate: boolean }>()
);
export const historyBookingDetailAction = createAction(
  type('[UserHistory/DATA] Fetch history booking detail'),
  props<{ response: HistoryBookingDetail, completed: boolean }>()
);

export const setHistoryDetailTypeAction = createAction(
  type('[UserHistory/UI] Set history detail type'),
  props<{ detailType: ReservationType, userId: string, detailId: string }>()
);

export const setHistoryDetailTitleAction = createAction(
  type('[UserHistory/UI] Set history detail title'),
  props<{ title: string }>()
);

export const fetchBookingPoliciesAction = createAction(
  type('[UserHistory/API] Fetch booking policies'),
  props<{ payload: BookingPoliciesPayload, defaultActions: Action[] }>()
);
export const fetchBookingPoliciesSuccessAction = createAction(
  type('[UserHistory/DATA] Fetch booking policies success'),
  props<{ response: BookingPoliciesResponse }>()
);
export const fetchBookingPoliciesErrorAction = createAction(
  type('[UserHistory/API] Fetch booking policies error')
);

export const exchangeSearchAction = createAction(
  type('[UserHistory/API] Exchange search'),
  props<{ payload: RequestSearchPayload }>()
);
export const exchangeSearchSuccessAction = createAction(
  type('[UserHistory/DATA] Exchange search success'),
  props<{ response: ExchangeSearchPayload }>()
);
export const exchangeBookAction = createAction(
  type('[UserHistory/API] Exchange booking'),
  props<{ payload: ExchangeBookPayload, flightKeys: string, freeOfCharge: boolean, exchangeWithAssistance: boolean }>()
);
export const exchangeBookSuccessAction = createAction(
  type('[UserHistory/DATA] Exchange booking success'),
  props<{ response: ExchangeBookResponse }>()
);

export const fetchRappiPaymentChangeAction = createAction(
  type('[Booking/API] Fetch Rappi payment change'),
  props<{ payload: RappiPayment, exchangeResponse: ExchangeBookResponse, exchangeWithAssistance: boolean }>()
);
export const fetchRappiPaymentChangeDesktopAction = createAction(
  type('[Booking/API] Fetch Rappi payment change desktop'),
  props<{ payload: RappiPayment, exchangeResponse: ExchangeBookResponse, exchangeWithAssistance: boolean }>()
);
export const fetchRappiPaymentChangeSuccessAction = createAction(
  type('[Booking/API] Fetch Rappi payment change success'),
  props<{ response: RappiPaymentResponse }>()
);
export const fetchRappiPaymentChangeErrorAction = createAction(
  type('[Booking/API] Fetch Rappi payment change error')
);
export const fetchRappiIntermediaryPaymentChangeDesktopAction = createAction(
  type('[Booking/API] Fetch Rappi intermediary payment change desktop'),
  props<{ response: RappiPaymentResponse, exchangeResponse: ExchangeBookResponse }>()
);

export const tabSelectedAction = createAction(
  type('[UserHistory/DATA] Tab Selected Action'),
  props<{ tab: UserHistoryOptions }>()
);

export const fetchReponseCancellation = createAction(
  type('[Home/API] Fetch Response Cancellation'),
  props<{ itineraryId: string, reason: CancellationReasonSumbitVM }>()
);
export const responseSuccessCancellation = createAction(
  type('[Home/API] Fetch Response Success Flight Cancellation'),
  props<{ response: CancellationSuccessType }>()
);
export const responseFailureFlightCancellation = createAction(
  type('[Home/API] Fetch Response Failure Flight Cancellation'),
  props<{ response: CancellationFailureType }>()
);

export const resetCancellationReasons = createAction(
  type('[Home/API] Reset Cancellation Reasons')
);

export const fetchItineraryValidateAction = createAction(
  type('[UserHistory/API] Fetch ItineraryValidateAction'),
  props<{ response: string }>()
);
export const fetchItineraryValidateSuccessAction = createAction(
  type('[UserHistory/API] Fetch Response Success Itinerary Validate'),
  props<{ response: FullHistoryBookingDetail }>()
);
export const fetchEventLastItineraryConfirmed = createAction(
  type('[UserHistory/API] Fetch event success Itinerary confirmed'),
  props<{ response: HistoryBookingDetail }>()
);

export const fetchLastUserReservationAction = createAction(
  type('[UserHistory/API] Fetch Last user reservation')
);
export const fetchLastUserReservationActionSuccess = createAction(
  type('[UserHistory/API] Fetch Last user reservation success'),
  props<{ response: HistoryBookingDetail }>()
);
export const readyLastReservationAction = createAction(
  type('[UserHistory/API] Ready Last user reservation')
);
export const fetchRappiItineraryByOrderDetailAction = createAction(
  type('[UserHistory/API] Fetch Rappi Itinerary By OrderId'),
  props<{ orderId: string }>()
);
export const fetchRappiItineraryByOrderDetailActionSuccess = createAction(
  type('[UserHistory/API] Fetch Rappi Itinerary by order id reservation success'),
  props<{ response: HistoryBookingDetail }>()
);

export const resetDetailReservationAction = createAction(
  type('[UserHistory/API] Reset detail reservation')
);

export const resendVoucherAction = createAction(
  type('[UserHistory/API] Resend voucher'),
  props<{ email: string, itinerary: number }>()
);

export const resendVoucherSuccessAction = createAction(
  type('[UserHistory/API] Resend voucher success')
);
